/**
 * Account namespece
 */
export namespace Account {
    ////////////////////////////////////////////////////
    ///
    /// EVENTS
    ///
    ////////////////////////////////////////////////////

    /**
     * Custom data update event
     */
    export const CUSTOMER_DATA_UPDATE_EVENT = 'account.customer.data.update';

    /**
     * Account off canvas menu toggle request event
     */
    export const OFF_CANVAS_TOGGLE_REQUEST_EVENT = 'off-canvas-account-menu.toggle.request';

    ////////////////////////////////////////////////////
    ///
    /// IDS
    ///
    ////////////////////////////////////////////////////

    /**
     * Name of the off canvas menu toggle block
     */
    export const MENU_OFF_CANVAS_NAME = 'off-canvas-account-menu';

    ////////////////////////////////////////////////////
    ///
    /// INTERFACES
    ///
    ////////////////////////////////////////////////////

    /**
     * Account navigation item
     */
    export interface INavigationItem {
        label: string;
        link?: string;
        type?: string;
        icon?: string;
        isHidden?: boolean;
    }

    /**
     * Edit account form data
     */
    export interface IEditFormData {
        firstname?: string;
        lastname?: string;
        currentPassword?: string;
        email?: string;
        password?: string;
        confirmPassword?: string;
        prefix?: string;
        dob?: string;
    }
}
